import Helper from 'src/app/core/utility/helper';
import { Component, OnInit, EventEmitter, Output, Input, ViewChild, AfterViewInit } from '@angular/core';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { DataService } from 'src/app/services/data.service';
import { ProposalService } from 'src/app/services/proposal.service';
import { ToastService } from 'src/app/services/toaster/toaster.service';
import { FormService } from 'src/app/services/form';
import { Router } from '@angular/router';
import { QueryApprovedPECreateDTO } from 'src/app/models/internal/query-approved-pe-create';
import { CopyFromProposalDTO } from 'src/app/models/internal/copyfrom-proposal-dto';
import { BaseGridPage } from 'src/app/core/basepages/allbasepages';
import { of } from 'rxjs';
import { LocalstorageService } from 'src/app/services/localstorage.service';
import { QueryProposalDTO } from 'src/app/models/internal/query-proposal-dto';
import { Constants } from 'src/app/core/constants';
import { AppSettings } from './../../../app.settings';
import { SourceType } from 'src/app/models/sourcetype';
import { TeslaAutocompleteComponent } from '@tesla/angular2-tesla-common/autocomplete/autocomplete.component';
import { NGXLogger } from 'ngx-logger';
import { formatDate } from '@angular/common';


@Component({
  selector: 'app-copyfrom-proposal-list',
  templateUrl: './copyfrom-proposal-list.component.html',
  styleUrls: ['./copyfrom-proposal-list.component.scss']
})
export class CopyfromProposalListComponent extends BaseGridPage implements OnInit, AfterViewInit {
  appSettings: AppSettings;
  copyFromProposalDTO: CopyFromProposalDTO = new CopyFromProposalDTO();
  @Output() private CopyClicked: EventEmitter<CopyFromProposalDTO> = new EventEmitter<
  CopyFromProposalDTO
>();
  private _POUoM: string;
  @Input() showComponent = false;
  @Input() isForSupplier = false;
  @Input() queryApprovedPECreateDTO: QueryApprovedPECreateDTO;
  @Input() POUoM: string;
  copypfromroposalsForm: FormGroup;
  showProposalsToCopyFoundMessage = false;
  showProposalsToCopyNotFoundMessage = false;
  sourceProposalsToCopyFromList: any[];
  sourcePartInfoId: number;
  sourceEffectivityFrom: Date;
  sourceProposalId: number;
  copySourceUom: string;
  filterForm: FormGroup;
  sourceTypeList: SourceType[];
  minEffectiveFromDate: Date;
  displayedColumns: string[] = [
    'Select',
    'PartNumber',
    'POUomCode',
    'ViewProposal'
];
public formErrors = {
  itemsSelectedSource: '',
  EffectiveFrom: '',
};
searchSupplierURL: string;
@ViewChild('SupplierAutoComplete') SupplierAutoComplete: TeslaAutocompleteComponent;

  constructor(
    private dataService: DataService,
    private fb: FormBuilder,
    private proposalService: ProposalService,
    private toastService: ToastService,
    public formService: FormService,
    localstorageService: LocalstorageService,
    private router: Router,
    logger: NGXLogger,
    appSettings: AppSettings,
  ) {
    super(localstorageService, logger, appSettings);
    this.copypfromroposalsForm = this.fb.group({
      itemsSelectedSource: [null],
      EffectiveFrom: [
          null,
          [Validators.required],
      ],
  });
  this.filterForm = this.fb.group({
    PartNumber: [null],
    SupplierCode: [null],
    SourceTypeId: [null],
  });
  this.appSettings = appSettings;
  this.searchSupplierURL = this.appSettings.Packaging2APIUrl + '/externaldata/supplier/all';
  /**
   * TMS-15424 Remove ability to backdate proposals
   * Users should not be able to provide an effective start date which is in the past.
   * The earliest Effective start date should be the next day of today.
   */
  this.minEffectiveFromDate = Helper.addDays(new Date(), 1);
  }

  // @Input() set POUoM(value: string)
  // {
  //   this._POUoM = value;
  // };

  // get POUoM(): string {
  //   return this._POUoM;
  // }

  ngOnInit() {
    this.initFilterValues();
  }

  fillGrid(): void {
    if (!this.sourceTypeList || this.sourceTypeList.length === 0) {
      this.getSourceTypes();
    }
    this.filter.Skip = this.skip;
    this.filter.Take = this.pageSize;
    if (this.isForSupplier) {
      this.getProposalsForSupplier(this.POUoM);
    } else {
      this.getProposalsForPE(this.queryApprovedPECreateDTO);
    }
}
setDefaultPartNumber(partNumber: string) {
  this.filterForm.controls['PartNumber'].setValue(partNumber);
}
getSourceTypes() {
  this.dataService.getParentSourceTypes().subscribe((response: any) => {
      if (response && response.Data != null) {
          this.sourceTypeList = response.Data;
      }
  });
}
onEmptySupplierCode(eventObj: any): void {
  this.filterForm.controls['SupplierCode'].patchValue(null);
  this.SupplierAutoComplete.list = [];
  if (this.filter != null && this.filter.SearchFilterConditions != null && this.filter.SearchFilterConditions.findIndex(x => x.Field === 'SupplierCode') >= 0) {
      this.filter.SearchFilterConditions.splice(this.filter.SearchFilterConditions.findIndex(x => x.Field === 'SupplierCode'), 1);
  }
}

UpdateFilter() {
    this.filter.SearchFilterConditions = [];
    this.filter = this.setFilterCondition(this.filter, this.filterForm, 'PartNumber', Constants.FILTER_DATATYPE_STRING,  Constants.FILTER_OPERATOR_TYPE_LIKE);
    this.filter = this.setFilterCondition(this.filter, this.filterForm, 'SupplierCode', Constants.FILTER_DATATYPE_STRING,  Constants.FILTER_OPERATOR_TYPE_EQUAL);
    this.filter = this.setFilterCondition(this.filter, this.filterForm, 'SourceTypeId', Constants.FILTER_DATATYPE_NUMBER,  Constants.FILTER_OPERATOR_TYPE_EQUAL);
  }
clearFilter() {
    this.filterForm.reset();
    this.filter.SearchFilterConditions = [];
    this.search();
}
  setSourcePart(element) {
    this.sourceProposalId = element.Id;
    this.sourcePartInfoId = element.PartInfoId;
    this.sourceEffectivityFrom = element.EffectiveFrom;
    this.copySourceUom = element.POUomCode;
    if (element) {
        if (this.sourceProposalId) {
            this.copypfromroposalsForm.controls[
                'itemsSelectedSource'
            ].setErrors(null);
        }
    }
}

  showCopyOptions() {
    return (
        this.sourceProposalsToCopyFromList &&
        this.sourceProposalsToCopyFromList.length > 0
    );
}
viewProposal(id: number) {
  this.proposalService.RefreshproposalToViewId(id);
  window.open('viewproposal/' + id, '_blank');
}

formatDate(unformattedDate: Date) {
  return Helper.formatDate(unformattedDate);
}

copyProposal() {
  this.ValidateCopyForm();
  if (this.copypfromroposalsForm.valid) {
     // TMS-37612 - Check if overlapping eff from date with source proposal and prompt the user
    var targetEffectiveFromDate = new Date(this.getEffectivityDate());
    var sourceEffectiveFromDate = new Date(this.sourceEffectivityFrom);
    if(targetEffectiveFromDate < sourceEffectiveFromDate)
     {
      // prompt and abort accordingly
      console.log('target date less than source');
      var confirmPrompt = Constants.CONFIRM_PROMPT_COPY_EARLIER_TARGET_DATE_1  + this.formatDate(sourceEffectiveFromDate) + Constants.CONFIRM_PROMPT_COPY_EARLIER_TARGET_DATE_2; 
      var OkToProceed = window.confirm(confirmPrompt);
      if(!OkToProceed){       
        return;      
      }
      }
    this.copyFromProposalDTO.SourcePartInfoId = this.sourcePartInfoId;
    this.copyFromProposalDTO.SourceProposalId = this.sourceProposalId;
    this.copyFromProposalDTO.EffectiveFrom = this.getEffectivityDate();
  this.CopyClicked.emit(this.copyFromProposalDTO);
  }
}


getEffectivityDate() {
    return   this.copypfromroposalsForm.controls[
        'EffectiveFrom'].value;
}

getProposalsForPE(queryApprovedPECreateDTO: QueryApprovedPECreateDTO) {
  this.UpdateFilter();
  queryApprovedPECreateDTO.SearchFilter = this.filter;
    this.dataService
    .getExistingApprovedProposals_PE(queryApprovedPECreateDTO)
    .subscribe((response: any) => {
        this.processResponse(response);
    });
}

getProposalsForSupplier(POUoM: string) {
  this.UpdateFilter();
  const queryProposalDTO: QueryProposalDTO = new QueryProposalDTO();
  queryProposalDTO.POUoM = POUoM;
  queryProposalDTO.SearchFilter = this.filter;
  this.dataService
  .getExistingApprovedProposals_Supplier(queryProposalDTO)
  .subscribe((response: any) => {
    this.processResponse(response);
    this.scrollToBottom();
  });

}

processResponse(response: any) {
  if (response != null) {
    this.sourceProposalsToCopyFromList = response.Data;
    this.gridView = of({
      data: response.Data,
      total: response.Total ? response.Total : 0,
  });
    if (response.Data && response.Data.length > 0) {
    this.showProposalsToCopyFoundMessage = true;
    this.showProposalsToCopyNotFoundMessage = false;
    } else {
        this.showProposalsToCopyNotFoundMessage = true;
        this.showProposalsToCopyFoundMessage = false;
    }
}

}



ValidateCopyForm() {
    if (!this.sourceProposalId) {
        this.copypfromroposalsForm.controls[
            'itemsSelectedSource'
        ].setErrors({ selectAtLeastOneGridRow: true });
        // this.formErrors.partNumberSelection = "Please select at least one part number";
    } else {
        this.copypfromroposalsForm.controls[
            'itemsSelectedSource'
        ].setErrors(null);
    }
    var nextDay = Helper.addDays(new Date(), 1);
    var userGivenEffectivityDate = this.getEffectivityDate();
    if(!Helper.validateEffectiveFromDate(userGivenEffectivityDate, nextDay))
    {
      this.copypfromroposalsForm.controls[
        'EffectiveFrom'
    ].setErrors({ invalidEffectiveFromDate: true });;
    }
    this.formErrors = this.formService.validateForm(
        <FormGroup>this.copypfromroposalsForm,
        this.formErrors
    );
}

}
